<app-auth-shell [testimonial]="false" [wide]="true">
  <app-auth-header
    [title]="'pages.auth.notificationPreferences.title' | transloco"
    [subtitle]="'pages.auth.notificationPreferences.subtitle' | transloco" />

  <h2 class="mt-8 mb-3 text-sm font-medium tracking-tight text-zinc-200">
    {{ 'resources.notificationSchedule.plural.long' | transloco }}
  </h2>

  @if (isEmpty()) {
    <vx-panel variant="group">
      <div class="flex flex-col items-start gap-1">
        <p class="text-sm font-medium tracking-tight text-zinc-200">
          {{ 'resources.notificationSchedule.empty.header' | transloco }}
        </p>
        <p class="text-sm tracking-tight text-zinc-400">
          {{ 'pages.auth.notificationPreferences.emptyHint' | transloco }}
        </p>
      </div>
    </vx-panel>
  } @else {
    <vx-panel variant="list">
      @for (
        entity of scheduleEntitiesIterable().entities;
        track entity.data?.id
      ) {
        @if (entity.data; as schedule) {
          <vx-list-row>
            <vx-item-cell
              icon="clock"
              [title]="schedule.name"
              [subtitle]="translateCronExpression(schedule.cronExpression)" />
            <div vxRowActions class="flex items-center gap-3">
              <vx-switch
                [ngModel]="schedule.enabled"
                (ngModelChange)="setScheduleEnabled(schedule.id, $event)"
                [ariaLabel]="
                  'resources.notificationSchedule.actions.toggle' | transloco
                " />
              <vx-icon-button
                icon="trash"
                variant="ghost"
                tone="secondary"
                size="sm"
                [ariaLabel]="
                  'resources.notificationSchedule.actions.delete.long'
                    | transloco
                "
                (click)="deleteSchedule(schedule.id)" />
            </div>
          </vx-list-row>
        }
      }
    </vx-panel>
  }

  <vx-button
    class="mt-8 self-start"
    size="lg"
    variant="outline"
    routerLink="/dashboard">
    {{ 'pages.auth.notificationPreferences.openDashboard' | transloco }}
  </vx-button>
</app-auth-shell>
